export const canadaStateOptions = [
  { ID: "AB", name: "Alberta" },
  { ID: "BC", name: "British Columbia" },
  { ID: "MB", name: "Manitoba" },
  { ID: "NB", name: "New Brunswick" },
  { ID: "NL", name: "Newfoundland and Labrador" },
  { ID: "NS", name: "Nova Scotia" },
  { ID: "NT", name: "Northwest Territories" },
  { ID: "NU", name: "Nunavut" },
  { ID: "ON", name: "Ontario" },
  { ID: "PE", name: "Prince Edward Island" },
  { ID: "QC", name: "Quebec" },
  { ID: "SK", name: "Saskatchewan" },
  { ID: "YT", name: "Yukon" },
];
